import { render, staticRenderFns } from "./Richmenu.vue?vue&type=template&id=6729324e&scoped=true&"
import script from "./Richmenu.vue?vue&type=script&lang=js&"
export * from "./Richmenu.vue?vue&type=script&lang=js&"
import style0 from "./Richmenu.vue?vue&type=style&index=0&id=6729324e&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6729324e",
  null
  
)

export default component.exports